(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('productFactory', productFactory);

    productFactory.$inject = ['uuid2', 'guard', 'workspace', 'eventService'];

    function productFactory(uuid2, guard, workspace, eventService) {
        var factoryApi = {
            createByFile: createByFile,
            createByModelId: createByModelId,
            createByParams: createByParams,
            clone: clone
        };

        function Product(file, units, modelId) {
            this.id = uuid2.newguid();
            this.file = file;
            this.units = units;
            this.productTemplateId = workspace.settings.productTemplateId;

            this.state = 'Initial';

            // Product properties
            this._material = angular.undefined;
            this._colour = angular.undefined;
            this._scale = 1;
            this._quantity = 1;

            this.model = {
                id: modelId,
                status: angular.undefined,
                result: angular.undefined,
                previewInfo: angular.undefined,
                measureUnit: angular.undefined,

                dimsMm: {
                    w: 0,
                    h: 0,
                    l: 0
                }
            };

            this.upload = {
                progress: 0
            };

            this.salesPrice = angular.undefined;

            this.issue = angular.undefined;
        }

        Product.prototype = {
            getModelName: getModelName,

            material: materialGetSet,
            colour: colourGetSet,
            scale: scaleGetSet,
            quantity: quantityGetSet,

            selectMaterialColour: selectMaterialColour,
            initMaterialColour: initMaterialColour,
            isMaterialColourDraft: isMaterialColourDraft,

            onPropertiesChanged: onPropertiesChanged
        };

        return factoryApi;

        // ------------------------------------------ Public functions ---------------------------------------------------

        function createByFile(file, units) {
            return new Product(file, units, undefined);
        }

        function createByModelId(modelId) {
            return new Product(undefined, undefined, modelId);
        }

        function createByParams(modelId, materialId, colourId, scale, quantity) {
            var product = createByModelId(modelId);

            product._material = { id: materialId };
            product._colour = { id: colourId };
            product._scale = scale;
            product._quantity = quantity;

            return product;
        }

        function clone(product) {
            var newProduct = angular.copy(product);
            newProduct.id = uuid2.newguid();

            return newProduct;
        }

        // ---------------------------------------------------- API --------------------------------------------------

        function scaleGetSet(scale) {
            var product = this;

            if (angular.isUndefined(scale)) {
                return product._scale;
            }

            guard.argumentHasValue(scale, "scale");

            product._scale = scale;
            notifyPropertiesChanged(product);

            return angular.undefined;
        }

        function quantityGetSet(value) {
            var product = this;

            if (angular.isUndefined(value)) {
                return product._quantity;
            }

            guard.argumentHasValue(value, "quantity");

            product._quantity = value;
            notifyPropertiesChanged(product);

            return angular.undefined;
        }

        function materialGetSet(material) {
            var product = this;

            if (angular.isUndefined(material)) {
                return product._material;
            }

            guard.argumentHasValue(material, "material");

            // don't notify PropertiesChanged here. Because event will be raised twice (on material and colour changes)
            product._material = material;
            product.colour(material.colours[0]);

            return angular.undefined;
        }

        function colourGetSet(colour) {
            var product = this;

            if (angular.isUndefined(colour)) {
                return product._colour;
            }

            guard.argumentHasValue(colour, "colour");

            product._colour = colour;
            notifyPropertiesChanged(product);

            return angular.undefined;
        }

        function selectMaterialColour(material, colour) {
            var product = this;

            guard.argumentHasValue(material, "material");
            guard.argumentHasValue(colour, "colour");

            if (material.id === product._material.id && colour.id === product._colour.id) {
                return;
            }

            product.initMaterialColour(material, colour);
            notifyPropertiesChanged(product);
        }

        function initMaterialColour(material, colour) {
            var product = this;

            guard.argumentHasValue(material, "material");
            guard.argumentHasValue(colour, "colour");

            product._material = material;
            product._colour = colour;
        }

        function getModelName() {
            var product = this;

            var fileName = getFileName(product);
            return fileName ? removeExtension(fileName) : null;
        }

        function getFileName(product) {
            if (product.model.fileName) {
                return product.model.fileName;
            }

            if (product.file) {
                return product.file.name;
            }

            if (product.uploadedFile) {
                return product.uploadedFile.fileName;
            }

            return null;
        }

        function removeExtension(filename) {
            var lastDotPosition = filename.lastIndexOf(".");
            if (lastDotPosition === -1) {
                return filename;
            } else {
                return filename.substr(0, lastDotPosition);
            }
        }

        function onPropertiesChanged(scope, callback) {
            var product = this;
            eventService.subscribe(scope, "Product-PropertiesChanged-" + product.id, callback);
        }

        function notifyPropertiesChanged(product) {
            eventService.notify("Product-PropertiesChanged-" + product.id, product);
        }

        function isMaterialColourDraft() {
            var product = this;

            return (product._material && angular.isUndefined(product._material.name))
                || (product._colour && angular.isUndefined(product._colour.name));
        }
    }
}());